import { billingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay";
import { checkoutReviewAndSubmitActionButtonsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { creditCardBillingAddressEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { paymentProfileBillingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import { shippingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay";
import { billingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import { cartTotalStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { containerStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import { shippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

containerStyles.cartTotalGridItemNarrow = {
    width: [12, 12, 12, 0, 0],
};
containerStyles.fulfillmentMethodAndAddressesGridItem = {
    width: [12, 12, 12, 8, 8],
};
containerStyles.cartTotalGridItemWide = {
    width: [0, 0, 0, 12, 12],
};
containerStyles.fulfillmentMethodAndNotesGridItem = {
    width: 0,
};

shippingAddressStyles.headingText = {
    css: css`
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 20px !important;
                        ~ button {
                            font-size: 15px !important;
                        }
                    `,
                    null,
                    css`
                        font-size: 17px;
                        ~ button {
                            font-size: 15px !important;
                        }
                    `,
                    css`
                        font-size: 17px;
                        ~ button {
                            font-size: 13px;
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
};

billingAddressStyles.headingText = {
    css: css`
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 20px !important;
                        ~ button {
                            font-size: 15px !important;
                        }
                    `,
                    null,
                    css`
                        font-size: 17px;
                        ~ button {
                            font-size: 15px !important;
                        }
                    `,
                    css`
                        font-size: 17px;
                        ~ button {
                            font-size: 13px;
                        }
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
pageHeaderStyles.gridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: block;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
pageHeaderStyles.buttonsWrapper = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: relative;
                    width: 100%;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};
checkoutReviewAndSubmitHeaderStyles.gridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: none;
    `,
};
checkoutReviewAndSubmitActionButtonsStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    `,
};

checkoutReviewAndSubmitActionButtonsStyles.backButton = {
    variant: "secondary",
    css: css`
        span {
            text-transform: capitalize;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                ],
                "max",
            )}
    `,
};
shippingAddressInfoDisplayStyles.heading = {
    weight: 600,
    css: css`
        margin: 0 1rem 0 0;
        font-size: 16px;
    `,
};
billingAddressInfoDisplayStyles.heading = {
    weight: 600,
    css: css`
        margin: 0 1rem 0 0;
        font-size: 16px;
    `,
};
paymentProfileBillingAddressStyles.wrapper = {
    css: css`
        padding-top: 5px;
    `,
};
creditCardBillingAddressEntryStyles.container = { gap: 20 };
creditCardDetailsEntryStyles.creditCardDetailsContainer = { gap: 20 };
creditCardDetailsEntryStyles.expirationDateContainer = { gap: 20 };

cartTotalStyles.buttonsGridItem = {
    width: [0, 0, 0, 12, 12],
};
cartTotalStyles.container = {
    gap: 10,
    css: css`
        padding-top: 20px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    & + div[class^="GridWrapper"] .checkout-custom-footer {
                        display: none !important;
                    }
                `,
                css`
                    & + div[class^="GridWrapper"] .checkout-custom-footer {
                        display: none !important;
                    }
                `,
            ])};
    `,
};
